import React from 'react';

import {
  Flex,
  FlexProps,
  Text,
} from '@chakra-ui/react';

import { ReactComponent as PolygonSVG } from 'assets/polygon.svg';
import { Icon } from 'components';

import AccordionHeader from './Header';

import { ActivityStatus } from '../../enums/status';
import { ActivityTypes } from '../../enums/types';

const AccordionIcons = {
  [ActivityTypes.Collect]: 'dolly-flatbed-alt',
  [ActivityTypes.Delivery]: 'box-check',
  [ActivityTypes.Dispatch]: 'plane',
  [ActivityTypes.Transhipment]: 'repeat-alt',
};

interface SectionAccordionProps extends FlexProps{
  title?: string
  status?: string
  children?: any
  index?: number
  activity?: GenericObject
  type?: keyof typeof AccordionIcons
}

export default function Accordion({
  title = 'Nova atividade',
  status = ActivityStatus.Pending,
  children,
  type,
  activity,
  ...rest
}:SectionAccordionProps) {
  return (
    <Flex {...rest}>
      <Flex
        mr={4}
        minW={16}
        hidden={!activity}
        flexDir="column">
        <Text
          variant="smallBold"
          color="gray.600">Ponto {activity?.order}
        </Text>
        <Text
          variant="xSmallRegular"
          color="gray.600">{activity?.estimatedKm ?? 'N/A'}km
        </Text>
      </Flex>
      <Flex>
        <Flex
          mr={8}
          flexDir="column"
          align="center"
          justify="center">
          <Flex
            minW={9}
            minH={9}
            justify="center"
            align="center"
            bg="white"
            zIndex={2}
            borderRadius="full">
            <Icon
              name={AccordionIcons[type]}
              size="xl"
              color="primary.default"
            />
          </Flex>
          <Flex
            zIndex={1}
            bg="gray.200"
            w="px"
            h="100%"
            pb={5}
          />
        </Flex>
        <Flex
          h={9}
          align="center"
          left="1px"
          position="relative">
          <PolygonSVG />
        </Flex>
        <AccordionHeader
          title={title}
          status={status}>
          {children}
        </AccordionHeader>
      </Flex>
    </Flex>
  );
}
